import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import _ from "lodash";

import ActivitySlider from "./ActivitySlider";
import ActivityCategory from "./ActivityCategory";
import allActImg from "../../../assets/images/activities/all-act.png";
import teamActImg from "../../../assets/images/activities/act-team.png";
import sliceActImg from "../../../assets/images/activities/act-slice.png";
import squeezeActImg from "../../../assets/images/activities/act-squeeze.png";

const FindActivity = ({ onViewActivity, browse_activities }) => {
  const activity_types = _.get(browse_activities, "activity_types", []);
  const categories = _.get(browse_activities, "categories", []);
  const category_label = _.get(
    browse_activities,
    "category_label",
    "Find activities and category:"
  );
  const label = _.get(browse_activities, "label", "Find Team Activities");
  const slices = _.get(browse_activities, "slices", {});
  const squeezes = _.get(browse_activities, "squeezes", {});
  const team_blenders = _.get(browse_activities, "team_blenders", {});

  const [activityTypes, setactivityTypes] = useState(
    activity_types.map((item, index) => ({
      name: item.split(" ")[0].toLowerCase().replace(":", ""),
      text: item,
      selected: index === 0 ? true : false
    }))
  );
  const [categoryTypes, setCategoryTypes] = useState(
    categories.map((item) => ({ text: item.toLowerCase(), selected: false }))
  );
  const [selectedActivities, setSelectedActivities] = useState({
    all: true,
    slices: slices.activities,
    squeezes: squeezes.activities,
    team_blenders: team_blenders.activities
  });

  const getActivitiesBasedOnCategories = (array, selected_categories) => {
    return array.activities.filter((item) =>
      selected_categories.some((category) =>
        item.categories.includes(
          category.text.charAt(0).toUpperCase() + category.text.slice(1)
        )
      )
    );
  };

  useEffect(() => {
    let selected_activity = activityTypes.find((item) => item.selected);
    let selected_categories = categoryTypes.filter((item) => item.selected);
    let result = {
      all: true,
      slices: [],
      squeezes: [],
      team_blenders: []
    };
    if (selected_activity.name === "all") {
      if (!_.isEmpty(selected_categories)) {
        result.squeezes = getActivitiesBasedOnCategories(
          squeezes,
          selected_categories
        );
        result.slices = getActivitiesBasedOnCategories(
          slices,
          selected_categories
        );
        result.team_blenders = getActivitiesBasedOnCategories(
          team_blenders,
          selected_categories
        );
      } else {
        result.slices = slices.activities;
        result.squeezes = squeezes.activities;
        result.team_blenders = team_blenders.activities;
      }
    } else {
      result.all = false;
      if (selected_activity.name === "squeeze") {
        if (!_.isEmpty(selected_categories)) {
          result.squeezes = getActivitiesBasedOnCategories(
            squeezes,
            selected_categories
          );
        } else {
          result.squeezes = squeezes.activities;
        }
      } else if (selected_activity.name === "slice") {
        if (!_.isEmpty(selected_categories)) {
          result.slices = getActivitiesBasedOnCategories(
            slices,
            selected_categories
          );
        } else {
          result.slices = slices.activities;
        }
      } else if (selected_activity.name === "team") {
        if (!_.isEmpty(selected_categories)) {
          result.team_blenders = getActivitiesBasedOnCategories(
            team_blenders,
            selected_categories
          );
        } else {
          result.team_blenders = team_blenders.activities;
        }
      }
    }
    setSelectedActivities({ ...result });
  }, [activityTypes, categoryTypes, squeezes, slices, team_blenders]);

  const handleChangeActivity = (activity) => {
    const array = activityTypes.map((item) =>
      item.name === activity.name
        ? { ...item, selected: true }
        : { ...item, selected: false }
    );
    setactivityTypes([...array]);
  };

  const handleChangeCategory = (category) => {
    const array = categoryTypes.map((item) =>
      item.text === category.text ? { ...item, selected: !item.selected } : item
    );
    setCategoryTypes([...array]);
  };

  const handleViewAll = (activity_name) => {
    const activity = activityTypes.find((item) =>
      activity_name.split(" ")[0].toLowerCase().includes(item.name)
    );
    setCategoryTypes((prev) =>
      prev.map((item) => ({ ...item, selected: false }))
    );
    handleChangeActivity(activity);
  };

  const getFilteredActivities = () => {
    let result = {};
    for (const activity in selectedActivities) {
      if (!_.isEmpty(selectedActivities[activity])) {
        result = { label: activity, activities: selectedActivities[activity] };
      }
    }
    return result;
  };

  return (
    <section className="find-team-activities">
      <h2 className="text">{label}</h2>
      <Row>
        {activityTypes?.map((item, index) => (
          <Col key={index} md={6} lg={3}>
            <div
              className={`act-tab ${item.selected ? "active" : ""}`}
              onClick={() => handleChangeActivity(item)}
            >
              <img
                src={
                  item.name === "all"
                    ? allActImg
                    : item.name === "squeeze"
                    ? squeezeActImg
                    : item.name === "slice"
                    ? sliceActImg
                    : teamActImg
                }
                className="img-fluid img"
                alt=""
              />
              <p className="mb-0 text">{item.text}</p>
            </div>
          </Col>
        ))}
      </Row>

      <div className="category-tabs">
        <h3 className="txt">{category_label}</h3>
        <div className="category-tabs__flex">
          {categoryTypes?.map((item, index) => (
            <button
              key={index}
              className={`tab ${item.selected ? "active" : ""}`}
              onClick={() => handleChangeCategory(item)}
            >
              {item.text}
            </button>
          ))}
        </div>
      </div>
      {/* <ActivitySlider activity_type={squeezes} /> */}
      {selectedActivities.all ? (
        <>
          <ActivitySlider
            onViewAll={handleViewAll}
            onViewActivity={onViewActivity}
            activity_type={{
              ...squeezes,
              activities: selectedActivities.squeezes
            }}
          />
          {!_.isEmpty(selectedActivities.slices) && (
            <>
              <div className="border-line" />
              <ActivitySlider
                onViewAll={handleViewAll}
                onViewActivity={onViewActivity}
                activity_type={{
                  ...slices,
                  activities: selectedActivities.slices
                }}
              />
            </>
          )}
          {!_.isEmpty(selectedActivities.team_blenders) && (
            <>
              <div className="border-line" />
              <ActivitySlider
                onViewAll={handleViewAll}
                onViewActivity={onViewActivity}
                activity_type={{
                  ...team_blenders,
                  activities: selectedActivities.team_blenders
                }}
              />
            </>
          )}
        </>
      ) : (
        <ActivityCategory
          onViewActivity={onViewActivity}
          getFilteredActivities={getFilteredActivities}
        />
      )}
    </section>
  );
};

export default FindActivity;
